import { render } from "./ProductSeries.vue?vue&type=template&id=c1004692&scoped=true"
import script from "./ProductSeries.vue?vue&type=script&lang=js"
export * from "./ProductSeries.vue?vue&type=script&lang=js"

import "./ProductSeries.vue?vue&type=style&index=0&id=c1004692&scoped=true&lang=css"

import exportComponent from "D:\\my\\game-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1004692"]])

export default __exports__